import i18n from '../../i18n/config';
import { useTranslation } from 'react-i18next';
// Preferencias del usuario para mensajes de ADOPCIÓN/engagement (separadas de alarmas/tickets).
import React, { useEffect, useState } from 'react';
import {
  Card, CardContent, Typography, Stack, FormControlLabel, Switch, TextField, MenuItem,
  Box, CircularProgress, Divider, Chip,
} from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { api } from '../../services/api';
import { useNotification } from '../common/GlobalNotifications';

export default function AdoptionNotificationPreferences() {
  const { t } = useTranslation();
  const { showError } = useNotification();
  const [prefs, setPrefs] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let ok = true;
    api.adoption.getPreferences().then((r) => { if (ok) setPrefs(r.data); }).catch(() => {}).finally(() => ok && setLoading(false));
    return () => { ok = false; };
  }, []);

  const save = async (patch) => {
    const next = { ...prefs, ...patch }; setPrefs(next); setSaving(true);
    try { const r = await api.adoption.updatePreferences(patch); setPrefs(r.data); }
    catch (e) { showError(t('hardcoded.components_settings_adoptionnotificationpreferences.no_se_pudo_guardar_la')); }
    finally { setSaving(false); }
  };

  if (loading) return <Box sx={{ py: 2, textAlign: 'center' }}><CircularProgress size={22} /></Box>;
  if (!prefs) return null;

  return (
    <Card variant="outlined" sx={{ mb: 3, borderColor: 'rgba(211,47,47,0.25)' }}>
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
          <AutoAwesomeIcon color="primary" fontSize="small" />
          <Typography variant="h6" fontWeight={700}>{t('hardcoded.components_settings_adoptionnotificationpreferences.mensajes_de_adopcion_y_recordatorios')}</Typography>
          {saving && <CircularProgress size={14} />}
        </Stack>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t('hardcoded.components_settings_adoptionnotificationpreferences.recordatorios_para_aprovechar_mejor_la')}</Typography>
        <Stack spacing={0.5}>
          <FormControlLabel control={<Switch checked={!!prefs.email_enabled} onChange={(e) => save({ email_enabled: e.target.checked })} />} label={t('hardcoded.components_settings_adoptionnotificationpreferences.recibir_recordatorios_por_email')} />
          <FormControlLabel control={<Switch checked={!!prefs.web_push_enabled} onChange={(e) => save({ web_push_enabled: e.target.checked })} />} label={t('hardcoded.components_settings_adoptionnotificationpreferences.recibir_recordatorios_por_notificacion_del')} />
          <FormControlLabel control={<Switch checked={!!prefs.operational_recommendations} onChange={(e) => save({ operational_recommendations: e.target.checked })} />} label={t('hardcoded.components_settings_adoptionnotificationpreferences.recibir_recomendaciones_operativas')} />
          <FormControlLabel control={<Switch checked={!!prefs.ticket_task_reminders} onChange={(e) => save({ ticket_task_reminders: e.target.checked })} />} label={t('hardcoded.components_settings_adoptionnotificationpreferences.recibir_recordatorios_de_tickets_y')} />
        </Stack>
        <Divider sx={{ my: 1.5 }} />
        <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
          <TextField select size="small" label={t('hardcoded.components_settings_adoptionnotificationpreferences.frecuencia')} value={prefs.frequency || 'auto'} onChange={(e) => save({ frequency: e.target.value })} sx={{ minWidth: 180 }}>
            <MenuItem value="auto">{t('hardcoded.components_settings_adoptionnotificationpreferences.automatica')}</MenuItem>
            <MenuItem value="daily">{t('hardcoded.components_settings_adoptionnotificationpreferences.diaria')}</MenuItem>
            <MenuItem value="weekly">{i18n.t('hardcoded.components_settings_adoptionnotificationpreferences.semanal')}</MenuItem>
            <MenuItem value="never">{t('hardcoded.components_settings_adoptionnotificationpreferences.nunca_desactivar')}</MenuItem>
          </TextField>
          {prefs.frequency === 'never' && <Chip size="small" color="default" label={t('hardcoded.components_settings_adoptionnotificationpreferences.no_recibiras_mensajes_de_adopcion')} />}
        </Stack>
      </CardContent>
    </Card>
  );
}
